define('environmentConfig',[], function () {
    "use strict";

    /**
     * Domain-based deployment environment definitions.
     * Keys from this object are matched against the end of
     * the domain when config is generated, so 'foo.bar.com'
     * will match 'bar.com'
     *
     * only overrides to defaultConfig.js need to be specified here
     *
     * URI definitions are handled via separate object properties
     * for the relevant parts of the URI, such that
     * 'https://public-api.us-east-1.inindca.com:8000/api/v1'
     * would be represented as:
     *  {
     *      protocol: 'https',
     *      hostname: 'public-api.us-east-1.inindca.com',
     *      port: '8000',
     *      path: '/api/v1',
     *  }
     *
     * The 'port' and 'path' properties are both optional
     */
    var ENVIRONMENTS = {
        "inindca.com": {
            localLogLevel: "debug",
            serverLogLevel: "warn",
            api: {
                hostname: "api.inindca.com"
            },
            architect: {
                hostname: "apps.inindca.com"
            },
            notifications: {
                hostname: "carrier-pigeon.us-east-1.inindca.com"
            },
            uploadService: {
                hostname: "apps.inindca.com"
            },
            uploadServicev4: {
                hostname: "apps.inindca.com"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.inindca.com/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.inindca.com/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.inindca.com",
                path: "/journey"
            },
            gaKey: "UA-59054556-1"
        },

        "inintca.com": {
            localLogLevel: "debug",
            serverLogLevel: "warn",
            api: {
                hostname: "api.inintca.com"
            },
            architect: {
                hostname: "apps.inintca.com"
            },
            notifications: {
                hostname: "carrier-pigeon.us-east-1.inintca.com"
            },
            uploadService: {
                hostname: "apps.inintca.com"
            },
            uploadServicev4: {
                hostname: "apps.inintca.com"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.inintca.com/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.inintca.com/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.inintca.com",
                path: "/journey"
            },
            gaKey: "UA-59050475-1"
        },

        "ininsca.com": {
            localLogLevel: "error",
            api: {
                hostname: "api.ininsca.com"
            },
            architect: {
                hostname: "apps.ininsca.com"
            },
            notifications: {
                hostname: "carrier-pigeon.us-east-1.ininsca.com"
            },
            uploadService: {
                hostname: "apps.ininsca.com"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.ininsca.com/scripter"
            },
            gaKey: "UA-59045071-1"
        },

        "mypurecloud.com": {
            localLogLevel: "error",
            api: {
                hostname: "api.mypurecloud.com"
            },
            architect: {
                hostname: "apps.mypurecloud.com"
            },
            notifications: {
                hostname: "carrier-pigeon.us-east-1.mypurecloud.com"
            },
            uploadService: {
                hostname: "apps.mypurecloud.com"
            },
            uploadServicev4: {
                hostname: "apps.mypurecloud.com"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mypurecloud.com/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mypurecloud.com/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mypurecloud.com",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "usw2.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.usw2.pure.cloud"
            },
            architect: {
                hostname: "apps.usw2.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.usw2.pure.cloud"
            },
            uploadService: {
                hostname: "apps.usw2.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.usw2.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.usw2.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.usw2.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.usw2.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "mypurecloud.com.au": {
            localLogLevel: "error",
            api: {
                hostname: "api.mypurecloud.com.au"
            },
            architect: {
                hostname: "apps.mypurecloud.com.au"
            },
            notifications: {
                hostname: "carrier-pigeon.ap-southeast-2.mypurecloud.com.au"
            },
            uploadService: {
                hostname: "apps.mypurecloud.com.au"
            },
            uploadServicev4: {
                hostname: "apps.mypurecloud.com.au"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mypurecloud.com.au/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mypurecloud.com.au/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mypurecloud.com.au",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "mypurecloud.ie": {
            localLogLevel: "error",
            api: {
                hostname: "api.mypurecloud.ie"
            },
            architect: {
                hostname: "apps.mypurecloud.ie"
            },
            notifications: {
                hostname: "carrier-pigeon.eu-west-1.mypurecloud.ie"
            },
            uploadService: {
                hostname: "apps.mypurecloud.ie"
            },
            uploadServicev4: {
                hostname: "apps.mypurecloud.ie"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mypurecloud.ie/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mypurecloud.ie/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mypurecloud.ie",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "mypurecloud.jp": {
            localLogLevel: "error",
            api: {
                hostname: "api.mypurecloud.jp"
            },
            architect: {
                hostname: "apps.mypurecloud.jp"
            },
            notifications: {
                hostname: "carrier-pigeon.ap-northeast-1.mypurecloud.jp"
            },
            uploadService: {
                hostname: "apps.mypurecloud.jp"
            },
            uploadServicev4: {
                hostname: "apps.mypurecloud.jp"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mypurecloud.jp/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mypurecloud.jp/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mypurecloud.jp",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "mypurecloud.de": {
            localLogLevel: "error",
            api: {
                hostname: "api.mypurecloud.de"
            },
            architect: {
                hostname: "apps.mypurecloud.de"
            },
            notifications: {
                hostname: "carrier-pigeon.eu-central-1.mypurecloud.de"
            },
            uploadService: {
                hostname: "apps.mypurecloud.de"
            },
            uploadServicev4: {
                hostname: "apps.mypurecloud.de"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mypurecloud.de/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mypurecloud.de/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mypurecloud.de",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "apne2.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.apne2.pure.cloud"
            },
            architect: {
                hostname: "apps.apne2.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.apne2.pure.cloud"
            },
            uploadService: {
                hostname: "apps.apne2.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.apne2.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.apne2.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.apne2.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.apne2.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "apne3.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.apne3.pure.cloud"
            },
            architect: {
                hostname: "apps.apne3.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.apne3.pure.cloud"
            },
            uploadService: {
                hostname: "apps.apne3.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.apne3.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.apne3.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.apne3.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.apne3.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "aps1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.aps1.pure.cloud"
            },
            architect: {
                hostname: "apps.aps1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.aps1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.aps1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.aps1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.aps1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.aps1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.aps1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "cac1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.cac1.pure.cloud"
            },
            architect: {
                hostname: "apps.cac1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.cac1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.cac1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.cac1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.cac1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.cac1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.cac1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "euc2.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.euc2.pure.cloud"
            },
            architect: {
                hostname: "apps.euc2.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.euc2.pure.cloud"
            },
            uploadService: {
                hostname: "apps.euc2.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.euc2.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.euc2.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.euc2.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.euc2.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "euw2.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.euw2.pure.cloud"
            },
            architect: {
                hostname: "apps.euw2.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.euw2.pure.cloud"
            },
            uploadService: {
                hostname: "apps.euw2.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.euw2.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.euw2.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.euw2.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.euw2.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "mec1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.mec1.pure.cloud"
            },
            architect: {
                hostname: "apps.mec1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.mec1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.mec1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.mec1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mec1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mec1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mec1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "sae1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.sae1.pure.cloud"
            },
            architect: {
                hostname: "apps.sae1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.sae1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.sae1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.sae1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.sae1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.sae1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.sae1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "use2.us-gov-pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.use2.us-gov-pure.cloud"
            },
            architect: {
                hostname: "apps.use2.us-gov-pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.use2.us-gov-pure.cloud"
            },
            uploadService: {
                hostname: "apps.use2.us-gov-pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.use2.us-gov-pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.use2.us-gov-pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.use2.us-gov-pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.use2.us-gov-pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },

        "use2.maximus-pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.use2.maximus-pure.cloud"
            },
            architect: {
                hostname: "apps.use2.maximus-pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.use2.maximus-pure.cloud"
            },
            uploadService: {
                hostname: "apps.use2.maximus-pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.use2.maximus-pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.use2.maximus-pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.use2.maximus-pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.use2.maximus-pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },
        
        "mxc1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.mxc1.pure.cloud"
            },
            architect: {
                hostname: "apps.mxc1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.mxc1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.mxc1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.mxc1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.mxc1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.mxc1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.mxc1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        },
        
        "apse1.pure.cloud": {
            localLogLevel: "error",
            api: {
                hostname: "api.apse1.pure.cloud"
            },
            architect: {
                hostname: "apps.apse1.pure.cloud"
            },
            notifications: {
                hostname: "carrier-pigeon.apse1.pure.cloud"
            },
            uploadService: {
                hostname: "apps.apse1.pure.cloud"
            },
            uploadServicev4: {
                hostname: "apps.apse1.pure.cloud"
            },
            scripter: {
                protocol: "https",
                hostname: "apps.apse1.pure.cloud/scripter"
            },
            qualityForms: {
                protocol: "https",
                hostname: "apps.apse1.pure.cloud/quality-forms"
            },
            journey: {
                protocol: "https",
                hostname: "apps.apse1.pure.cloud",
                path: "/journey"
            },
            gaKey: "UA-59040562-1"
        }
    };

    return ENVIRONMENTS;
});

